import { LoginEffects } from '@modules/autenticacion/login/store/effects';
import { RentOperationEffects } from '@modules/master/rent-operation/store/effects';

export const effects = [RentOperationEffects, LoginEffects];
